import { MoreVerticalIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'

import { ChatHeaderActionsMenuItems } from './chat-header-actions-menu-items.molecule'

interface ChatHeaderActionsMenuProps {
  onSettings?: () => void
  onArchive?: () => void
  onInvite?: () => void
  onLeave?: () => void
  isLeaveDisabled?: boolean
  className?: string
}

/**
 * Dropdown menu with chat actions (share, invite, settings, archive, leave).
 * Triggered by a vertical 3-dot button.
 */
export const ChatHeaderActionsMenu: React.FC<ChatHeaderActionsMenuProps> = ({
  onSettings,
  onArchive,
  onInvite,
  onLeave,
  isLeaveDisabled = false,
  className,
}): ReactNode => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        variant="ghost"
        size="sm"
        className={cn('chat-header-actions-trigger px-2', className)}
        aria-label="Chat actions"
      >
        <MoreVerticalIcon className="size-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="chat-header-actions-menu w-48">
      <ChatHeaderActionsMenuItems
        onSettings={onSettings}
        onArchive={onArchive}
        onInvite={onInvite}
        onLeave={onLeave}
        isLeaveDisabled={isLeaveDisabled}
      />
    </DropdownMenuContent>
  </DropdownMenu>
)

ChatHeaderActionsMenu.displayName = 'ChatHeaderActionsMenu'
